module.exports = __webpack_public_path__ + "static/media/11.56dc0906.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyes/11.png
// module id = 1221
// module chunks = 0